import cx from "classnames";
import moment from "moment";
import Select from "react-select";
import useLang from "../../../hooks/use-lang.hook";
import plusIcon from "../../../_assets/vectors/plus-gray-icon.svg";
import quizOptionCorrect from "../../../_assets/vectors/quiz-option-correct-icon.svg";
import quizOption from "../../../_assets/vectors/quiz-option-icon.svg";
import quizQuestionRemoveIcon from "../../../_assets/vectors/quiz-question-remove-icon.svg";
import DropDown from "../../atoms/drop-down.component";
import I18 from "../../atoms/i18";
import { FormError } from "../../form-error.component";

export const QUIZ_QUESTION_SKELETON = {
  statement: "",
  options: ["", "", "", ""],
  answer: "",
};

export function CreatePostPoll({
  errors,
  isQuestion = false,
  setIsQuestion = () => {},
  isQuiz = false,
  setIsQuiz = (e) => {},
  quizTitle = "",
  setQuizTitle = () => {},
  quizDuration = 10,
  setQuizDuration = () => {},
  quizInstruction = "",
  setQuizInstruction = () => {},
  quizQuestions = [],
  setQuizQuestions = () => {},
  endTime = null,
  setEndTime = () => {},
}) {
  const updateQuestion = (index, question) => {
    const newQuizQuestions = [...quizQuestions];
    newQuizQuestions.splice(index, 1, question);
    setQuizQuestions(newQuizQuestions);
  };

  const pollOptions = [
    { value: 12, label: '12 Hours' },
    { value: 24, label: '1 Day' },
    { value: 48, label: '2 Days' },
    { value: 168, label: '1 Week' },
    { value: 336, label: '2 Weeks' },
    { value: 87600, label: 'Unlimited' },
  ];

  return (
    <div className="CreatePostQuiz mt-5">
      {/* quiz switcher */}
      {/* <div
                className="bg-card p-4 flex justify-between items-center"
                style={{ margin: "1rem -1rem" }}>
                <span>Toggle to Quiz</span>
                <InputSwitch selected={isQuiz} onClick={setIsQuiz} />
            </div> */}
      {/* question switcher */}
      <div className="bg-card p-4" style={{ margin: "1rem -1rem" }}>
        <DropDown
          className=""
          options={[
            {
              label: "Question",
              value: false,
              name: "question",
            },
            {
              label: "Poll",
              value: true,
              name: "poll",
            },
          ]}
          value={{
            label: isQuestion ? "Question" : "Poll",
            value: isQuestion,
          }}
          onChange={(value) => {
            if (isQuestion) {
              // turning to poll, make the mods
              const newQuestion = { ...quizQuestions[0] };
              setQuizQuestions([newQuestion]);
            } else {
              // turning to question make the mods
              const newQuestion = { ...quizQuestions[0] };
              if (newQuestion.options.length > 4) {
                newQuestion.options.length = 4;
              }
              while (newQuestion.options.length < 4) {
                newQuestion.options.push("");
              }
              setQuizQuestions([newQuestion]);
            }
            setIsQuestion(!isQuestion);
          }}
        />
      </div>
      {/* poll expires */}
      {!isQuestion ? (
        <div>
          <div className="font-semibold text-secondary-foreground/85">
            <I18>Poll expire time</I18>
          </div>
          <div className="mt-2">
            <Select
              className="w-full cursor-pointer rounded border-border bg-card text-secondary-foreground/85 outline-none"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: "hsl(var(--border))",
                  color: "hsl(var(--secondary-foreground))",
                  backgroundColor: "hsl(var(--card))",
                  cursor: "pointer",
                }),
                placeholder: (baseStyles, state) => ({
                  ...baseStyles,
                  color: "hsl(var(--secondary-foreground))",
                }),
                menu: (baseStyles, state) => ({
                  ...baseStyles,
                  color: "hsl(var(--secondary-foreground))",
                }),
                menuList: (baseStyles, state) => ({
                  ...baseStyles,
                  backgroundColor: "hsl(var(--card))",
                  borderColor: "hsl(var(--border))",
                }),

                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    fontFamily: data.label,
                    padding: "5px 10px",
                    ...styles,
                    backgroundColor: "hsl(var(--card))",
                    cursor: "pointer",
                    color: "hsl(var(--secondary-foreground))",
                    ":hover": {
                      backgroundColor: "hsl(var(--background))",
                      color: "hsl(var(--secondary-foreground))",
                    },
                  };
                },
                singleValue: (baseStyles, state) => ({
                  ...baseStyles,
                  color: "hsl(var(--secondary-foreground))",
                }),
              }}
              options={pollOptions}
              placeholder="Enter Test Title here"
              onChange={(selectedOption) => {
                setEndTime(moment().add(selectedOption.value, 'h'));
              }}>
            </Select>
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* questions list */}
      {quizQuestions.map((question, index) => (
        <div key={index} className="my-5">
          <QuizQuestion
            isQuestion={isQuestion}
            index={index}
            question={question}
            updateQuestion={updateQuestion}
          />
          <FormError
            error={
              errors &&
              errors.questions &&
              errors.questions[index] &&
              errors.questions[index].statement
            }
          />
          <QuizOptions
            index={index}
            question={question}
            isQuestion={isQuestion}
            errors={
              errors &&
              errors.questions &&
              errors.questions[index] &&
              errors.questions[index].options
            }
            updateQuestion={updateQuestion}
          />
          <FormError
            error={
              errors &&
              errors.questions &&
              errors.questions[index] &&
              errors.questions[index].answer
            }
          />
          {/* Add new poll option */}
          {!isQuestion ? (
            <div className="my-5">
              <button
                className="flex items-center justify-center text-xs font-semibold focus:outline-none"
                onClick={(e) => {
                  const newQuestion = { ...question };
                  newQuestion.options.push("");
                  updateQuestion(0, newQuestion);
                }}>
                <span className="flex h-5 w-5 items-center justify-center rounded-full border border-border">
                  <img src={plusIcon} alt="Add Option" width="12px" />
                </span>
                <span className="px-2">
                  <I18>Add Option</I18>
                </span>
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      ))}
    </div>
  );
}

function QuizQuestion({ index, question, isQuestion, updateQuestion }) {
  let rows = question.statement.split("\n").length;
  rows = rows > 0 ? rows : 1;
  const lang = useLang();

  return (
    <div className="QuizQuestion">
      <div className="mb-4 flex">
        <span className="font-semibold text-secondary-foreground/85">
          {isQuestion ? <I18>Question</I18> : <I18>Poll question</I18>}
        </span>
      </div>
      <textarea
        type="text"
        value={question.statement}
        onChange={(e) => {
          updateQuestion(index, {
            ...question,
            statement: e.target.value,
          });
          window.setTimeout(() => {
            e.target.style.height = "auto";
            e.target.style.height = e.target.scrollHeight + "px";
          }, 0);
        }}
        className="block w-full rounded-lg border border-border bg-card px-4 py-3 hover:shadow focus:outline-none"
        rows={rows}
        placeholder={lang.trans("Enter Question")}
      />
    </div>
  );
}

function QuizOptions({ index, question, isQuestion, errors, updateQuestion }) {
  const lang = useLang();
  return (
    <div className="QuizOptions my-2">
      <span className="font-semibold text-secondary-foreground/85">
        <I18>Options</I18>
      </span>
      {question.options.map((option, optionIndex) => (
        <div key={optionIndex} className="QuizOption my-2">
          <div className="flex">
            {/* show option to select answer if question */}
            {isQuestion ? (
              <img
                src={
                  option && question.answer === option
                    ? quizOptionCorrect
                    : quizOption
                }
                width="20px"
                alt="Quiz Option"
                className="cursor-pointer"
                onClick={(e) => {
                  // set this option as answer
                  updateQuestion(index, {
                    ...question,
                    answer: option,
                  });
                }}
              />
            ) : (
              <></>
            )}
            <input
              type="text"
              placeholder={lang.trans("Option") + " " + (optionIndex + 1)}
              className={cx(
                "block w-full rounded-lg border border-border bg-card px-4 py-3 hover:shadow focus:outline-none",
                {
                  "ml-3": isQuestion,
                  "mr-3": !isQuestion,
                }
              )}
              value={option}
              onChange={(e) => {
                const newOptions = [...question.options];
                newOptions.splice(optionIndex, 1, e.target.value);
                updateQuestion(index, {
                  ...question,
                  options: newOptions,
                });
              }}
            />
            {isQuestion || optionIndex < 2 ? (
              <></>
            ) : (
              <img
                src={quizQuestionRemoveIcon}
                width="20px"
                alt="Remove option"
                className="mx-2 cursor-pointer"
                onClick={(e) => {
                  // remove this option
                  const newQuestion = { ...question };
                  const { options } = newQuestion;
                  options.splice(optionIndex, 1);
                  newQuestion.options = options;
                  updateQuestion(0, newQuestion);
                }}
              />
            )}
          </div>
          <FormError
            error={errors && errors[optionIndex] && errors[optionIndex]}
          />
        </div>
      ))}
    </div>
  );
}
